module.exports = __webpack_public_path__ + "assets/img/hot-goods-bottom.6ceeee47.png";